define('app/views/vendor_deal_req_view',['app/setup'], function(takhfifan) {
  takhfifan.vendorDealReqView = takhfifan.BaseView.extend({
    events: {
      'click .btn-wrapper .btn': 'submitRequest'
    },
    
    initialize: function() {
      var _this = this;
      Backbone.Validation.bind(this);
      this.url = this.$el.data('subscribe-url');
      takhfifan.eventHub.on('modal:closeModalWithContent', function(options) {
        _this.cleanup();
      }, this);
    },
    
    submitRequest: function() {
      var _this = this;
      this.model.set('email', this.$("#email").val());
      this.model.set('telephone', this.$("#telephone").val());
      this.model.validate();
      if (this.model.isValid()) {
        this.disableButton();

        $.post(
          this.url, {
            email: this.model.get('email'),
            telephone: this.model.get('telephone'),
            utm_source: _this.urlParam('utm_source'),
            utm_medium: _this.urlParam('utm_medium'),
            next: _this.urlParam('next'),
            id: _this.urlParam('id'),
            page_name: window.location.pathname
          },
          function(data) {
            var $messageBox = _this.$('.message-box');
            var successIcon =
              '<span class="status-icon icon-email"></span>';
            var errorIcon =
              '<span class="status-icon icon-error"></span>';
            var existIcon =
              '<span class="status-icon icon-close"></span>';
            if (data.result.status == "already-exists") {
              $messageBox.find('.status-icon').remove();
              $messageBox.find('.inner').prepend(existIcon);
              $messageBox.find('p').text(
                'قبلا درخواست خود را ثبت نموده‌اید');
              $messageBox.fadeIn();
              setTimeout(function() {
                $messageBox.find('input').val('');
                $messageBox.fadeOut();
                _this.closeModal();
                _this.cleanup();
              }, 2500);
              _this.enableButton();
            }
            else if (data.result.status && data.result.status == "success") {
              $messageBox.find('.status-icon').remove();
              $messageBox.find('.inner').prepend(successIcon);
              $messageBox.find('p').html('<span>درخواست شما با موفقیت ثبت شد</span>');
              $messageBox.fadeIn();
              _this.enableButton();
              setTimeout(function() {
                $messageBox.find('input').val('');
                _this.closeModal();
                _this.cleanup();
                $messageBox.fadeOut();
              }, 2500);
            } else {
              $messageBox.find('.status-icon').remove();
              $messageBox.find('.inner').prepend(errorIcon);
              $messageBox.find('p').text('خطا در ثبت اطلاعات');
              $messageBox.fadeIn();
              setTimeout(function() {
                $messageBox.find('input').val('');
                $messageBox.fadeOut();
                _this.closeModal();
              }, 2500);
              _this.enableButton();
            }
          }
        );
      }
    },
    
    cleanup: function() {
      this.$el.hide();
      this.undelegateEvents();
    },
    
    closeModal: function(options) {
      takhfifan.eventHub.trigger('modal:closeModalWithContent',options);
    },
    
    disableButton: function() {
      var $btn = this.$('.btn');
      $btn.data('label', $btn.text());
      var $loader = $('<span />').addClass('spinner');
      if ($btn.prop('disabled') != true) {
        $btn.prop('disabled', true).empty().append($loader);
      }
    },

    enableButton: function() {
      var $btn = this.$('.btn');
      $btn.find('.spinner').remove();
      $btn.prop('disabled', false).text($btn.data('label'));
    }
  });
});

